var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as constants from '@redbubble/design-system/src/constants';
import Header from '@redbubble/design-system/src/headerAndFooter/components/Header';
import PageSection from '@redbubble/design-system/src/PageSection';
import ProductNav from '@redbubble/design-system/src/ProductNav';
import { onSearchCallback, onTypeaheadResultClick, } from '@redbubble/next-analytics/gtm';
import { RSLinkClickedLocation, useRudderstackClient, } from '@redbubble/next-provider/rudderstack';
import React from 'react';
import { trackGA4GlobalNavViewCategory, trackGA4GlobalNavViewSubCategory, } from '../analytics';
import { CartItemsCount } from '../cart-items-count';
import { TopicNavWithConfig } from './TopicNav/TopicNavWithConfig';
import { useTopicNavExperiment } from './TopicNav/useTopicNavExperiment';
import { useSaleBannerExperiment } from './useSaleBannerExperiment';
export var AppHeader = function (_a) {
    // We have to determine device from the user-agent header and not viewport width
    // otherwise there can be mismatches between actual device type and that which would
    // be returned from useViewportWidth hook.
    // This is because when a client has a 768px viewport width doesnt mean it will be a tablet
    // when determined from useragent. iPads provide a desktop mac user-agent unless
    // specifically set otherwise.
    var headAndFooterVariant = _a.headAndFooterVariant, forceMobileHeader = _a.forceMobileHeader, intl = _a.intl, userInfo = _a.userInfo, globalNavigation = _a.globalNavigation, bannerMessages = _a.bannerMessages, deviceType = _a.deviceType, disableExpandedMobileSearch = _a.disableExpandedMobileSearch, disableStickySearch = _a.disableStickySearch, engagingPlaceholderMessages = _a.engagingPlaceholderMessages, searchTerm = _a.searchTerm, searchProductContext = _a.searchProductContext, type = _a.type, _b = _a.hideProductNavigation, hideProductNavigation = _b === void 0 ? false : _b, _c = _a.showAnimatedLogo, showAnimatedLogo = _c === void 0 ? true : _c, saleBannerMessages = _a.saleBannerMessages;
    // TODO: Remove this as soon as possible we should not be rendering different components based on user-agent
    var shouldUseMobileHeader = deviceType === 'mobile' || deviceType === 'tablet' || forceMobileHeader;
    var isTopicsTreatment = useTopicNavExperiment() !== 'legacy-nav';
    var saleBanner = useSaleBannerExperiment(bannerMessages, saleBannerMessages, intl);
    // NOTE(jj) 20260821: ProductNav is the "old" text navigation links.
    // We disable it when user is enrolled in the "topic" navigation treatment
    var renderProductNav = deviceType === 'desktop' && !hideProductNavigation && !isTopicsTreatment;
    // NOTE(jj) 20260821: TopicNav is the "experimental" navigation, with the
    // topics and products with icons. We disable the old text navigation when
    // a user is enrolled in the topic nav treatment
    var renderTopicNav = isTopicsTreatment && !hideProductNavigation;
    var profile = shouldUseMobileHeader ? constants.MOBILE : constants.DESKTOP;
    var showExpandedMobileSearch = !disableExpandedMobileSearch && shouldUseMobileHeader;
    var showHamburgerOnDesktop = renderTopicNav;
    var headerPosition = !disableStickySearch ? 'fixed' : 'relative';
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    return (React.createElement("header", null,
        React.createElement(CartItemsCount, { initialCount: userInfo === null || userInfo === void 0 ? void 0 : userInfo.cartItems }, function (cart) { return (React.createElement("div", { className: renderTopicNav ? 'rb-topics-header' : undefined },
            React.createElement(Header, __assign({ cart: cart, globalNavigation: globalNavigation, intl: intl, isServer: typeof window === 'undefined', profile: profile, userInfo: userInfo, useRainbowStyle: true, engagingPlaceholderMessages: engagingPlaceholderMessages, showExpandedMobileSearch: showExpandedMobileSearch, showHamburgerOnDesktop: showHamburgerOnDesktop, position: headerPosition, searchTerm: searchTerm, bannerMessages: bannerMessages }, saleBanner, { searchProductContext: searchProductContext, onTypeaheadResultClick: onTypeaheadResultClick, onSearchCallback: onSearchCallback, onNavItemClick: function (item, rootItem) {
                    trackGA4GlobalNavViewSubCategory(item, {
                        position: 'left_side',
                        parent: rootItem.label,
                    });
                    if (!RudderstackClient)
                        return;
                    RudderstackClient.linkClicked({
                        link_label: item.label,
                        location: RSLinkClickedLocation.NavSub,
                    });
                }, onNavItemView: function (item) {
                    return trackGA4GlobalNavViewCategory(item, {
                        position: 'left_side',
                    });
                }, type: type, showAnimatedLogo: showAnimatedLogo })))); }),
        renderTopicNav && (React.createElement(PageSection, null,
            React.createElement(TopicNavWithConfig, null))),
        renderProductNav && (React.createElement(ProductNav, __assign({ intl: intl, items: globalNavigation, peeking: true, bannerMessages: bannerMessages }, saleBanner, { onNavItemClick: function (item, rootItem) {
                trackGA4GlobalNavViewSubCategory(item, {
                    position: 'header',
                    parent: rootItem === null || rootItem === void 0 ? void 0 : rootItem.label,
                });
                if (!RudderstackClient)
                    return;
                RudderstackClient.linkClicked({
                    link_label: item.label,
                    location: RSLinkClickedLocation.NavSub,
                });
            } })))));
};
